import { fetchLandingAssets } from 'services/landing.service';

import { FETCH_LANDING_ASSETS } from './actionNames/landingActionNames';

export const fetchLandingAssetsAction = (tokenIds: string[]) => ({
  type: FETCH_LANDING_ASSETS,
  payload: fetchLandingAssets(tokenIds),
});
